import { render, staticRenderFns } from "./RootUserInfoView.vue?vue&type=template&id=2d826aa1&"
import script from "./RootUserInfoView.vue?vue&type=script&lang=ts&"
export * from "./RootUserInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports